import {connect} from "react-redux";
import SaveTag from "./Save";
import {bindActionCreators} from "redux";
import {createTag} from "services/redux/Valet/AddValet/action";

const mapStateToProps = (state) => ({
    tagCreation: state.CreateValet.tagCreation,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createTag
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaveTag);